<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字典类型">
            <a-select :disabled="this.params.isShow" placeholder="请选择字典类型" v-decorator="[
          'dictionaryType',
          {initialValue:data.dictionaryType,rules: [{ required: true, message: '请选择字典类型' }]}]">
              <!-- <a-select-option value="1">计量单位</a-select-option> -->
              <a-select-option value="2">通知类型</a-select-option>
              <!-- <a-select-option value="3">客户类别</a-select-option>
              <a-select-option value="4">产品系列</a-select-option> -->
              <!-- <a-select-option value="5">活动类型</a-select-option> -->
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字典名称">
            <a-input :disabled="params.isShow" placeholder="请输入字典名称" v-decorator="[
          'name',
          {initialValue:data.name,rules: [{ required: true, message: '请输入字典名称' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字典值">
            <a-input :disabled="this.params.isShow" placeholder="请输入字典值" v-decorator="[
          'value',
          {rules: [{ required: false, message: '请输入字典值' }],initialValue:data.value}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
            <a-select :disabled="this.params.isShow" placeholder="请选择状态" v-decorator="[
          'isActive',
          {initialValue:data.isActive,rules: [{ required: true, message: '请选择状态' }]}]">
              <a-select-option value="1">启用</a-select-option>
              <a-select-option value="0">禁用</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col class="form-row"></a-col>
      </a-row>

      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label>
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
const defaultData = {
  id: 0,
  name: "",
  value: "",
  dictionaryType: undefined,
  isActive: "1"
};
export default {
  name: "hp-manager-page-dictionary-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    };
  },

  async mounted() {
    if (this.params.id) {
      // this.data = Object.assign(this.params,defaultData)
      this.getdetailDictionary();
    } else {
      this.data = exzends(defaultData);
    }
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async getdetailDictionary() {
      this.loading = true;
      let result = await api.GetDictionary({ dictionaryId: this.params.id });
      if (result) {
        this.data = result;
        this.data.dictionaryType = this.data.dictionaryType + "";
        this.data.isActive = (this.data.isActive ? 1 : 0) + "";
      }
      this.loading = false;
    },
    async submitHandler() {
      await api.AddOrUpdateDictionary(requestData);
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        name: value.name,
        value: value.value,
        dictionaryType: parseInt(value.dictionaryType),
        isActive: parseInt(value.isActive) == 1
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let requestData = this.dataToPostData(valid.values);
        let data = await api.AddOrUpdateDictionary(requestData);
        if (data) {
          if (this.params.id > 0) {
            this.$message.success("修改成功");
          } else {
            this.$message.success("新增成功");
          }
          this.$emit("submit-success");
        }

        console.log(requestData);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Admins/Dictionary/Add.vue